import cx from 'classnames';

const FitmentContent = ({
  icon: Icon,
  iconColor,
  buttonTitle,
  isFitmentMobile = false
}) => {
  return (
    <div className={`cat-u-display-flex cat-u-padding-none text-start`}>
      <div
        className={cx(
          'cat-u-margin-top-sm cat-u-margin-bottom-sm d-flex align-items-start'
        )}
        data-testid="FitmentContent-container"
      >
        {Icon ? (
          <div
            className={cx('h-100', {
              'mt-1': isFitmentMobile,
              'mt-2': !isFitmentMobile
            })}
          >
            <Icon size={isFitmentMobile ? 'lg' : 'md'} color={iconColor} />
          </div>
        ) : null}
        {buttonTitle}
      </div>
    </div>
  );
};

export default FitmentContent;
